import { useQuery } from '@tanstack/react-query';

import type { IncidentType } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import processIncidentApiData from '@/utils/helpers/process-incident-api-data';

export const useGetIncidentListData = (options = {}) =>
  useQuery<IncidentType[]>({
    queryKey: ['incidents'],
    queryFn: async () => {
      const { data } = await axiosInstance.get<IncidentType[]>(API_ROUTES.incidentLists());

      return processIncidentApiData(data);
    },
    gcTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
    retry: false,
    ...options,
  });
